import React, {Fragment, useCallback, useState} from "react";
import {v4} from 'uuid'
import Button from "@mui/material/Button";
import {DialogTitle} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import PlusOneIcon from '@mui/icons-material/PlusOne';
import Grid from "@mui/material/Grid";
import {displayMod} from "../../_helper/displayMod";
import AddIcon from "@mui/icons-material/Add";
import {ICharMod} from "../../_interfaces/ICharMod";
import {useSignals} from "@preact/signals-react/runtime";
import ModEdit from "./ModEdit";
import modTitles from "./modTitles";
import {s_chars_mods} from "../../_signals/s_chars_mods";
import {s_app_cid, s_app_mobile, s_app_sl} from "../../_signals/s_app";

export default function Mods() {
    useSignals()

    const [open, setOpen] = useState(false)


    const add = useCallback(() => {
        const add: ICharMod = {
            id: v4(),
            cid: s_app_cid.value,
            what: '',
            mmod: 0,
            type: '',
            duration: 0,
            sl: s_app_sl.value,
            descr: '',
            disabled: false,
            msource: '',
            msourceid:'',
            strain: 0,
            mfrom: '',
            insert: true
        };
        let char_mods = s_chars_mods.value.get(s_app_cid.value);
        if (char_mods) {
            char_mods.set(add.id, add);
            s_chars_mods.value.set(s_app_cid.value, char_mods);
        }
    }, [])

    const mods = s_chars_mods.value.get(s_app_cid.value);
    let modsArray = mods ? Array.from(mods.values()) : [];

    return <Fragment>
        <Button className={'btn'} onClick={() => setOpen(true)}>
            Modifikatoren <PlusOneIcon/>
        </Button>

        <Dialog open={open}
                fullScreen={s_app_mobile.value}
                fullWidth={true}
                maxWidth={'xl'}
        >
            <DialogTitle key={v4()}>Modifikatoren
                <AddIcon onClick={() => add()} key={v4()}/>
            </DialogTitle>
            <DialogContent key={v4()}>
                <Grid container style={{maxHeight: 380}} key={v4()}>
                    {modsArray.map((mod, i, mods) => mod.disabled ?
                        <Fragment key={mod.id}>
                            <Grid item xs={12}>
                                {mod.mfrom} {modTitles[mod.what]} {displayMod(mod.mmod)}
                            </Grid>
                        </Fragment>
                        :
                        <ModEdit mod={mod} mods={mods.length} mnum={i} key={mod.id}/>)
                    }
                </Grid>
            </DialogContent>
            <DialogActions key={v4()}>
                <Button onClick={() => setOpen(false)}>schliessen</Button>
            </DialogActions>
        </Dialog>
    </Fragment>
}